import { Injectable } from '@angular/core';

import { HttpStatusCode } from '@nano/common/http';
import { NavService } from '@nano/common/nav';
import { ErrorService } from '@nano/core/error';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class HasAccount {
  constructor(
    private navService: NavService,
    private errorService: ErrorService
  ) {}

  hasAccount(): Observable<boolean> {
    return this.navService.hasAccount$.pipe(
      tap((hasAccount) => {
        if (!hasAccount) {
          this.errorService.navigateToErrorPage(HttpStatusCode.FORBIDDEN);
        }
      })
    );
  }

  canActivate(): Observable<boolean> {
    return this.hasAccount();
  }

  canLoad(): Observable<boolean> {
    return this.hasAccount();
  }
}
